import { TFunction } from 'i18next';
import { replaceAllSpaces } from 'src/lib/utils';
import { Construction, FacilityId } from 'src/models/resort/Construction';

export function getConstructionTheme(t: TFunction, construction: Construction) {
  if (construction.freeTheme) {
    return replaceAllSpaces(construction.freeTheme);
  } else if (construction.structureKind === 1) {
    switch (construction.facilityId) {
      case 0:
        return t('facility_0');
      case 1:
        return t('facility_1');
      case 2:
        return t('facility_2');
      case 3:
        return t('facility_3');
      case 4:
        return t('facility_4');
      default:
        return '';
    }
  } else {
    return '';
  }
}

export function getFacilityTheme(t: TFunction, freeTheme: string, facilityId: FacilityId) {
  if (freeTheme) {
    return replaceAllSpaces(freeTheme);
  } else {
    switch (facilityId) {
      case 0:
        return t('facility_0');
      case 1:
        return t('facility_1');
      case 2:
        return t('facility_2');
      case 3:
        return t('facility_3');
      case 4:
        return t('facility_4');
      default:
        return '';
    }
  }
}
